const jQ = jQuery.noConflict();

class Slider {
    constructor(sel, align = 'right', draggable = '>1', direction = 'previous', autoPlay = false, freeScroll = false) {
        this.selector = sel;
        this.align = align;
        this.draggable = draggable;
        this.direction = direction;
        this.autoPlay = autoPlay;
        this.freeScroll = freeScroll;
    }
    init() {
        const { align, draggable, direction, autoPlay, freeScroll } = this;

        function slideSettings() {
            const el = jQ(this);
            const options = {
                wrapAround: true,
                pageDots: false,
                cellAlign: align,
                contain: false,
                draggable,
                autoPlay,
                pauseAutoPlayOnHover: false,
                prevNextButtons: false,
                imagesLoaded: true,
                freeScroll,
            }
            if (jQ('.mobile-check').is(':visible')) {
                options.freeScroll = false;
            }

            el.flickity(options);

            el.on( 'staticClick.flickity', ( event, pointer, cellElement, cellIndex ) => {  el.flickity(direction); });

        }
        jQ(this.selector).each(slideSettings);
    }
}

const ProductSlider = new Slider('.single-product-silder');
const CollectionsSlider = new Slider('.taxonomy-slider', 'left', '>1', 'next', false, true);

export default ProductSlider;
export {CollectionsSlider};
